import React , {useEffect} from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";


const TeamWork = () => {

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);


  return (
    <div className="section most_features_section container-mid">

    <div className="d-flex-c" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >
    
    <div className="info_box"></div>
    <h1 className="main_headline">  فريق العمل </h1>
    </div>

    <div className="text-center section">
    <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="260"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="/images/icons/businesswoman.png" alt="" />
        <h1 className="headline_feaure_info">  فاطمة عطيف </h1>
        <h1 className="subheadline_feaure_info">   الرئيس التنفيذي </h1>
      </div>
    </div>
    
    <div className="d-flex-c f-sp f-wrap features_icons ">
    


      <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="260"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="/images/icons/majid.png" alt="" />
        <h1 className="headline_feaure_info">   ماجد عياش </h1>
        <h1 className="subheadline_feaure_info">    مستشار المشروع </h1>
      </div>
    
      <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="290"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="https://i.ibb.co/LYZ4SR2/heroarea-image.jpg" alt="" />
        <h1 className="headline_feaure_info">  عمار حمدي  </h1>
        <h1 className="subheadline_feaure_info">  مهندس برمجيات </h1>
      </div>
    
      <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="320"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="/images/icons/woman.png" alt="" />
        <h1 className="headline_feaure_info"> أثير جبلي</h1>
        <h1 className="subheadline_feaure_info">  مصمم الواجهات </h1>
      </div>
    
      <div className="single_feature_div" data-aos="zoom-in" data-aos-duration="350"   data-aos-easing="ease-in-quad" data-aos-mirror="true" >
        <img src="/images/icons/mofareh.png" alt="" />
        <h1 className="headline_feaure_info">  مفرح غزواني </h1>
        <h1 className="subheadline_feaure_info">  مطور اعمال </h1>
      </div>
    
    </div>
    
    </div>
    
  )
}

export default TeamWork